import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FilterNamePipe } from "./filter-name.pipe";
import { OrderByFieldPipe } from "src/pipes/order-by-field.pipe";
import { BigTranslationPipe } from "./big-translation.pipe";
import { GroupByIdDevicePipe } from "./group/grpup-by-id-device.pipe";
import { MapToArrayPipe } from "./map-to-array.pipe";
import { SearchByCodePipe } from "./search/search-by-code.pipe";
import { SupervisionPipe } from "./supervision-name.pipe";
import { FilterDateFormatterPipe } from "./date/filter-date-formatter.pipe";
import { ConvertObjectToMapFormatPipe } from "./convert-object-to-map-format.pipe";
import { DateTimeFormatter } from "./date/date-time-formatter.pipe";
import { FilterNameTreePipe } from "./filter-name-tree";

@NgModule({
  declarations: [
    FilterNameTreePipe,
    OrderByFieldPipe,
    MapToArrayPipe,
    MapToArrayPipe,
    BigTranslationPipe,
    SearchByCodePipe,
    GroupByIdDevicePipe,
    SupervisionPipe,
    FilterDateFormatterPipe,
    ConvertObjectToMapFormatPipe,
    DateTimeFormatter,
  ],
  // FilterNamePipe is standalone: the shared-components submodule imports it in its own standalone components
  imports: [CommonModule, FilterNamePipe],
  exports: [
    FilterNamePipe,
    FilterNameTreePipe,
    OrderByFieldPipe,
    MapToArrayPipe,
    BigTranslationPipe,
    SearchByCodePipe,
    GroupByIdDevicePipe,
    SupervisionPipe,
    FilterDateFormatterPipe,
    ConvertObjectToMapFormatPipe,
    DateTimeFormatter,
  ],
  providers: [
    FilterNamePipe,
    FilterNameTreePipe,
    OrderByFieldPipe,
    MapToArrayPipe,
    BigTranslationPipe,
    SearchByCodePipe,
    GroupByIdDevicePipe,
    SupervisionPipe,
    FilterDateFormatterPipe,
    ConvertObjectToMapFormatPipe,
    DateTimeFormatter,
  ],
})

/**
 *
 *  Simone: Pipe module for import in page when you use a custom pipe.
 *  When you add new pipe via ionic cli, you must:
 *  -  Import pipe references in this module
 *  -  Put Pipe name (export name class) in declarations and exports array
 *
 *  Then you import PipesModule in your desired page and put it into imports array of the module page
 *
 */
export class PipesModule {}
